import { render, staticRenderFns } from "./temperature.vue?vue&type=template&id=7917a8f8&scoped=true"
import script from "./temperature.vue?vue&type=script&lang=js"
export * from "./temperature.vue?vue&type=script&lang=js"
import style0 from "./temperature.vue?vue&type=style&index=0&id=7917a8f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7917a8f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7917a8f8')) {
      api.createRecord('7917a8f8', component.options)
    } else {
      api.reload('7917a8f8', component.options)
    }
    module.hot.accept("./temperature.vue?vue&type=template&id=7917a8f8&scoped=true", function () {
      api.rerender('7917a8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bigScreen/components/temperature.vue"
export default component.exports